import { useState, useEffect } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { INSTAGRAM_PROFILE_URL, TEL_HREF, WHATSAPP_CHAT_URL } from '../../../config/contactLinks';

const logoSrc = `${import.meta.env.BASE_URL}lyeni.png`;

const navLinks = [
  { label: 'Ana Sayfa', href: '/' },
  { label: 'Hizmetler', href: '/hizmetler' },
  { label: 'Hakkımızda', href: '/hakkimizda' },
  { label: 'Referanslar', href: '/referanslar' },
  { label: 'İletişim', href: '/iletisim' },
  { label: 'SSS', href: '/sss' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header className="fixed top-0 left-0 right-0 z-50 overflow-visible">
      {/* Top announcement bar */}
      <div className="bg-navy text-white text-xs font-medium">
        <div className="max-w-7xl mx-auto px-4 md:px-8 h-9 flex items-center justify-between">
          <span className="hidden sm:flex items-center gap-1.5 text-white/60">
            <span className="w-3 h-3 flex items-center justify-center">
              <i className="ri-map-pin-line"></i>
            </span>
            NiğPak Temizlik • Niğde Merkez
          </span>
          <div className="flex items-center gap-5">
            <a
              href={WHATSAPP_CHAT_URL}
              target="_blank"
              rel="nofollow noreferrer"
              className="flex items-center gap-1.5 text-white/80 hover:text-gold transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-whatsapp-line"></i>
              0543 191 0851
            </a>
            <a
              href="mailto:nigpaktemizlik@gmail.com"
              className="hidden md:flex items-center gap-1.5 text-white/80 hover:text-gold transition-colors cursor-pointer"
            >
              <i className="ri-mail-line"></i>
              nigpaktemizlik@gmail.com
            </a>
            <a
              href={INSTAGRAM_PROFILE_URL}
              target="_blank"
              rel="nofollow noreferrer"
              className="flex items-center gap-1.5 text-white/80 hover:text-gold transition-colors cursor-pointer"
            >
              <i className="ri-instagram-line"></i>
              <span>nigpak.temizlik</span>
            </a>
          </div>
        </div>
      </div>

      {/* Main navbar */}
      <nav
        className={`overflow-visible transition-all duration-300 ${
          scrolled ? 'bg-white/95 backdrop-blur-md border-b border-gray-100' : 'bg-white border-b border-gray-100'
        }`}
      >
        <div className="max-w-7xl mx-auto grid h-[84px] min-h-[84px] grid-cols-[1fr_auto] grid-rows-1 items-center gap-2 sm:gap-3 px-3 sm:px-4 md:px-6 md:grid-cols-[1fr_auto_1fr] overflow-visible">
          <Link
            to="/"
            className="relative z-10 col-start-1 row-start-1 flex h-[84px] min-w-0 cursor-pointer items-center justify-self-start overflow-visible"
          >
            <img
              src={logoSrc}
              alt="NiğPak Temizlik"
              className="block h-[84px] w-auto max-h-[84px] max-w-full origin-left scale-[1.22] object-contain object-left sm:scale-[1.26] md:scale-[1.24]"
            />
          </Link>

          <ul className="relative z-20 col-start-2 row-start-1 hidden items-center justify-center gap-3 self-center md:flex lg:gap-4 md:justify-self-center">
            {navLinks.map((link) => (
              <li key={link.href}>
                <NavLink
                  to={link.href}
                  end={link.href === '/'}
                  className={({ isActive }) =>
                    `text-[12px] lg:text-[13px] font-semibold transition-colors cursor-pointer whitespace-nowrap ${
                      isActive ? 'text-gold' : 'text-navy/70 hover:text-gold'
                    }`
                  }
                >
                  {link.label}
                </NavLink>
              </li>
            ))}
          </ul>

          <div className="relative z-20 col-start-2 row-start-1 flex items-center justify-end justify-self-end gap-1.5 sm:gap-2 md:col-start-3">
            <Link
              to="/iletisim"
              className="shrink-0 rounded-lg bg-navy px-2.5 py-2 text-[10px] font-bold uppercase tracking-wide text-white transition-colors hover:bg-gold sm:px-3 sm:text-[11px] md:hidden"
            >
              Teklif Al
            </Link>
            <a
              href={TEL_HREF}
              className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg border border-navy/15 text-navy transition-colors hover:border-gold hover:text-gold md:hidden"
              aria-label="Hemen ara"
            >
              <i className="ri-phone-line text-lg"></i>
            </a>
            <a
              href={WHATSAPP_CHAT_URL}
              target="_blank"
              rel="nofollow noreferrer"
              className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-[#25D366] text-white transition-opacity hover:opacity-90 md:hidden"
              aria-label="WhatsApp ile yaz"
            >
              <i className="ri-whatsapp-line text-xl"></i>
            </a>

            <a
              href={WHATSAPP_CHAT_URL}
              target="_blank"
              rel="nofollow noreferrer"
              className="hidden shrink-0 items-center gap-2 rounded-lg bg-navy px-5 py-2.5 text-[13px] font-bold whitespace-nowrap text-white cursor-pointer transition-colors hover:bg-gold md:flex"
            >
              <i className="ri-phone-line"></i>
              Ücretsiz Teklif Al
            </a>

            <button
              type="button"
              className="flex h-9 w-9 shrink-0 cursor-pointer items-center justify-center rounded-lg text-navy transition-colors hover:bg-gray-50 md:hidden"
              onClick={() => setMenuOpen(!menuOpen)}
              aria-label={menuOpen ? 'Menüyü kapat' : 'Menüyü aç'}
            >
              <i className={`${menuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
            </button>
          </div>
        </div>
      </nav>

      {menuOpen && (
        <div className="md:hidden bg-white border-b border-gray-100 px-4 pb-4">
          <ul className="flex flex-col pt-2">
            {navLinks.map((link) => (
              <li key={link.href}>
                <Link
                  to={link.href}
                  onClick={() => setMenuOpen(false)}
                  className="flex items-center py-3 text-navy text-sm font-semibold border-b border-gray-50 hover:text-gold transition-colors cursor-pointer"
                >
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
          <a
            href={WHATSAPP_CHAT_URL}
            target="_blank"
            rel="nofollow noreferrer"
            className="mt-3 flex items-center justify-center gap-2 bg-navy text-white px-5 py-3 rounded-lg text-sm font-bold cursor-pointer"
          >
            <i className="ri-whatsapp-line"></i> Ücretsiz Teklif Al
          </a>
        </div>
      )}
    </header>
  );
}
